"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Popup_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Popup"));
/**
 * The Popup component displays additional information on top of a page. It is a utility wrapper component for other Forge UI components.
 */
var Popup = /** @class */ (function (_super) {
    __extends(Popup, _super);
    function Popup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Popup.prototype.render = function () {
        var _a = this.props, element = _a.element, position = _a.position, offset = _a.offset, className = _a.className, children = _a.children, hoverable = _a.hoverable, open = _a.open, cleanedProps = __rest(_a, ["element", "position", "offset", "className", "children", "hoverable", "open"]);
        return (React.createElement(Popup_1.default, __assign({}, cleanedProps, { trigger: React.createElement("span", { className: this.props.on === 'click' ? 'popup-pointer' : '' }, element), position: position, offset: offset, basic: true, open: open, hoverable: hoverable, className: this.genInputClass() }), children));
    };
    Popup.prototype.genInputClass = function () {
        var classString = 'ui popup menu';
        if (this.props.className) {
            classString += " " + this.props.className;
        }
        return classString;
    };
    Popup.defaultProps = {
        position: 'bottom left',
        on: 'click',
        offset: '0, 0',
        hoverable: true,
    };
    return Popup;
}(React.Component));
exports.default = Popup;
